import moment from 'moment';
import React, { useEffect, useState } from 'react';
import Modal from 'react-bootstrap/Modal';

import { changeDateFormat } from '@utils/Util';

const DATE_FORMAT = 'YYYY-MM-DD';

/**
 * Signs the selected tasks off on the day the work actually finished rather than today, for a task
 * recorded after the fact. The date is held between the factory handover and today: nothing on a
 * TNA happens before the order reaches the factory, and a task cannot be finished in the future.
 * The backend holds the same two bounds, so a typed-in date out of range is refused there too.
 */
const CompleteOnPastDateModal = ({ show, onHide, taskCount, handoverDate, onConfirm }) => {
	const today = moment().format(DATE_FORMAT);
	const [completionDate, setCompletionDate] = useState('');

	// A fresh selection starts from an empty field, not whatever the last one was completed on.
	useEffect(() => {
		if (show) setCompletionDate('');
	}, [show]);

	const isFutureDate = completionDate !== '' && completionDate > today;
	const isBeforeHandover = completionDate !== '' && !!handoverDate && completionDate < handoverDate;
	const isOutOfRange = isFutureDate || isBeforeHandover;

	return (
		<Modal show={show} onHide={onHide} centered className="complete-on-past-date-modal">
			<Modal.Header closeButton>
				<h3 className="semibold-16 mb-0">Complete on a past date</h3>
			</Modal.Header>
			<Modal.Body>
				<div className="form-group mb-0">
					<label htmlFor="task-completion-date">Completion date (mm/dd/yyyy)</label>
					<input
						type="date"
						id="task-completion-date"
						value={completionDate}
						min={handoverDate || undefined}
						max={today}
						onChange={(e) => setCompletionDate(e.target.value)}
					/>
					{handoverDate && (
						<p className="regular-12 gray_dark_02 mt-2 mb-0">
							Handed over to the factory on{' '}
							{changeDateFormat(handoverDate, DATE_FORMAT, 'DD MMM YYYY')}. A task cannot be
							completed before that date.
						</p>
					)}
					{isOutOfRange && (
						<p className="error">
							{isFutureDate
								? 'A task cannot be completed on a future date.'
								: 'A task cannot be completed before the handover to factory date.'}
						</p>
					)}
				</div>
			</Modal.Body>
			<Modal.Footer>
				<button className="button outline size32 ml-2" onClick={onHide}>
					Cancel
				</button>
				<button
					className="button size32 ml-2"
					disabled={!completionDate || isOutOfRange}
					onClick={() => onConfirm(completionDate)}
				>
					Complete {taskCount} task
				</button>
			</Modal.Footer>
		</Modal>
	);
};

export default CompleteOnPastDateModal;
